// extracted by mini-css-extract-plugin
export default {"scannerImg":"BottomNavbar_scannerImg__pmSN2"};